import { Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { selectors, useAppSelector } from 'state/global-state';
import { isAnyWalmartOffer } from 'state/loyalty/hooks/utils/walmart';
import { LoyaltyOffer } from 'state/loyalty/types';
import { primitive, spacing } from 'styles/constants';

import { WalmartBadgeContainer } from './cart-item-offer';

export const CartItemOfferDiscountSkeleton = ({
  selectedLoyaltyOffer,
}: {
  selectedLoyaltyOffer: LoyaltyOffer;
}) => {
  const startEndColorProp = {
    startColor: primitive.$blackOpacity10,
    endColor: primitive.$whiteOpacity30,
  };
  const isWalmartOfferSelected = isAnyWalmartOffer(selectedLoyaltyOffer);
  const loyaltyWalmartUILoading = useAppSelector(selectors.loyalty.selectLoyaltyWalmartUILoading);
  return (
    <Box style={styles.container}>
      <Skeleton rounded="full" height="$4" width="$4" {...startEndColorProp} />
      <Box style={styles.content}>
        {(isWalmartOfferSelected || loyaltyWalmartUILoading) && (
          <WalmartBadgeContainer marginBottom="$0_5" />
        )}
        <Skeleton.Text {...startEndColorProp} lines={2} space={1} />
      </Box>
      <Box style={styles.actionContainer}>
        <Skeleton {...startEndColorProp} width="$12" height="$5" rounded={12} />
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    paddingVertical: spacing.$3,
    paddingHorizontal: spacing.$3,
    marginBottom: spacing.$3,
    borderRadius: 8,
    backgroundColor: primitive.$blackOpacity4,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actionContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    marginLeft: spacing.$12,
  },
  content: {
    flex: 1,
    marginLeft: spacing.$2,
  },
});
